import { Pipe, PipeTransform } from '@angular/core';
import { SdkDictionaryService } from '@dsivd/prestations-ng';

@Pipe({ name: 'displayBoolean' })
export class DisplayBooleanPipe implements PipeTransform {
    constructor(private dictionaryService: SdkDictionaryService) {
    }

    transform(value: boolean | number[], args?: string[]): any {
        if (typeof value !== 'boolean') {
            return value;
        }

        return value ?
            this.dictionaryService.getKeySync('display-boolean.true.label') :
            this.dictionaryService.getKeySync('display-boolean.false.label');
    }
}
